export default __webpack_public_path__ + "static/media/icon-copy.b6aab03d.svg";